import { PrefixToCurrencyMap, type LocalePrefix } from '@tmh-website/shared/const';

import type { Currency } from './tracify.contracts';

/**
 * Resolves the `Currency` applicable to the provided `LocalePrefix`.
 *
 * @param localePrefix - The `LocalePrefix` which corresponding `Currency` we want to get.
 */
export const getCurrencyByLocalePrefix = (localePrefix: LocalePrefix): Currency => {
  const currency = PrefixToCurrencyMap[localePrefix];

  if (typeof currency !== 'string') {
    throw new Error(`Failed to resolve the applicable Currency for the provided LocalePrefix '${localePrefix}'!`);
  }

  return currency as Currency;
};
